module.exports = __webpack_public_path__ + "img/xxtx.ee0b9c33.jpg";